import { render } from "./Header.vue?vue&type=template&id=9124b278&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "@/styles/components/header.scss?vue&type=style&index=0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__